import { render, staticRenderFns } from "./UnitPreview.vue?vue&type=template&id=2d236b08&scoped=true&"
import script from "./UnitPreview.vue?vue&type=script&lang=js&"
export * from "./UnitPreview.vue?vue&type=script&lang=js&"
import style0 from "./UnitPreview.vue?vue&type=style&index=0&id=2d236b08&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d236b08",
  null
  
)

component.options.__file = "UnitPreview.vue"
export default component.exports